export const fromRelayId = (id: string): string => atob(id).split(':')[1];
